import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons'
import ActionItem from './ActionItem'
import { DraftContext } from '../../../../../../contexts/DraftContext'

export default observer(function ActionInfluencerItem({ influencer }) {
  const { actionsForInfluencer } = useContext(DraftContext)
  const infActions = actionsForInfluencer(influencer.id)

  return (
    <div className="mb-3">
      <button
        className="w-full flex justify-between items-center p-2 rounded-lg bg-gray-50 dark:bg-rb-dark-mode-lighter"
        onClick={() => influencer.toggleExpanded()}
      >
        <span className="font-bold text-sm dark:text-white">{influencer.username}</span>
        {influencer.isExpanded ? <ChevronUp /> : <ChevronDown />}
      </button>

      {influencer.isExpanded && (
        <div className="pt-2">
          {infActions.map(action => <ActionItem key={action.id} action={action} />)}
        </div>
      )}
    </div>
  )
})
